const Filters = {
  init: function () {
    const filters = document.querySelector('[data-filters]');

    if (filters) {
      const transition_delay = 400; // manual sorry
    
      // wait page load before init
      window.addEventListener('load', () => {
    
        // set initial active filters
        let filter_active = filters.querySelectorAll('.filter.-active');
        if (filter_active.length > 0) filter_active.forEach(f => {
          let d = f.querySelector('.dropdown');
          d.style.height = `${d.scrollHeight}px`;
        });
    
      });
      
      // toggle open
      const opens = document.querySelectorAll('[data-filters-open]');
      if (opens.length > 0) opens.forEach(open => {
        open.addEventListener('click', () => { 
          filters.classList.add('-active');
          document.body.classList.add('-blocked');
        });
      });
    
      // toggle close
      const closes = document.querySelectorAll('[data-filters-close]');
      if (closes.length > 0) closes.forEach(close => { 
        close.addEventListener('click', () => { 
          filters.classList.remove('-active');
          document.body.classList.remove('-blocked');
          setTimeout(() => {
            let filter_options = filters.querySelectorAll('.filter');
            if (filter_options.length > 0) filter_options.forEach(f => {
              let a = f.querySelector('.anchor');
              let d = f.querySelector('.dropdown');
              if (f.classList.contains('-active')) {
                a.classList.add('-active');
                d.classList.add('-active');
                d.style.height = `${d.scrollHeight}px`;
              } else {
                d.style.height = 0;
                setTimeout(() => {
                  a.classList.remove('-active');
                }, transition_delay);
              }
            });
          }, transition_delay);
        });
      });
    
      // filters dropdown
      const selector = '.filter .anchor';
      const anchors = filters.querySelectorAll(selector);
      if (anchors.length > 0) anchors.forEach(anchor => {
        anchor.addEventListener('click', () => {
          const dropdown = anchor.nextElementSibling;
    
          if(anchor.classList.contains('-active')){
            anchor.classList.remove('-active');
            let span = anchor.querySelector('span');
            if (span) span.innerHTML = '+';
    
            dropdown.classList.remove('-active');
            dropdown.style.height = 0;
            
          } else {    
            if (filters.querySelector(`${selector}.-active`)) {
              let active_anchors = filters.querySelectorAll(`${selector}.-active`);
              active_anchors.forEach(active_anchor => {
                let active_dropdown = active_anchor.nextElementSibling;
                let span = active_anchor.querySelector('span');
                if (span) span.innerHTML = '+';
    
                active_anchor.classList.remove('-active');
                active_dropdown.classList.remove('-active');
                active_dropdown.style.height = 0;
              });
            }
    
            anchor.classList.add('-active');
            let span = anchor.querySelector('span');
            if (span) span.innerHTML = '-';

            dropdown.style.height = `${dropdown.scrollHeight}px`;
            setTimeout(() => {
              dropdown.classList.add('-active');
            }, transition_delay);
          }
        });
      });
    
    }
  }
}

export default Filters;
